<section class="auth_login__container">
  <footer>
    <div>
      <img src="../../../../assets/img/provart_logo.svg" alt="" />
    </div>
  </footer>
  
  <header>
    <h2>Inicio de sesión</h2>
    <p>Bienvenido a Medicina Laboral.</p>
  </header>
  <main>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <app-cx-field [label]="'Usuario'" [required]="true">
        <input formControlName="user" [(ngModel)]="loginReq.user" name="userId" id="userId" type="email" maxlength="20" />
      </app-cx-field>

      <div>
        <app-cx-field [label]="'Contraseña'" [required]="true">
          <input formControlName="pass" [(ngModel)]="loginReq.password" class="password" name="userPassword"
            id="userPassword" type="{{ typePassword }}" maxlength="50" />
        </app-cx-field>
        <div class="hide-show">
          <span (click)="hidePassword()" *ngIf="!isHidePassword">Mostrar</span>
          <span (click)="hidePassword()" *ngIf="isHidePassword">Ocultar</span>
        </div>
      </div>

      <app-cx-check-box (valueEvent)="receiveMessage()" label="Recordar usuario."></app-cx-check-box>

      <div>
        <button id="signIn_button" class="cx_button cx_button--primary" type="submit" [disabled]="!loginForm.valid">
          Ingresar
        </button>
      </div>

      <section class="auth_login__container__resetInfo">
        <span class="auth_login__container__resetInfo__tittle">¿Olvidó su usuario?</span>
        <div>
          <span>Escríbanos a:
            <span (click)="resetPasword()" class="auth_login__container__resetInfo__link">mesadeayuda@conexia.com</span>
            O llámenos al: 0810 810 2663
          </span>
        </div>
      </section>
    </form>
  </main>
</section>

<app-footer> </app-footer>